var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('select-single',{attrs:{"options":_vm.options},on:{"update":_vm.update}}),_c('div',{staticClass:"text-center mt-4"},[(_vm.gender)?_c('b-button',{attrs:{"variant":"success"},on:{"click":_vm.goNext}},[_vm._v("Continuer")]):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }